import PropertiesGetters from './PropertiesGetters';
import PropertiesState from './PropertiesState';
import PropertiesMutations from './PropertiesMutations';
import PropertiesActions from './PropertiesActions';

export default {
    state: PropertiesState,
    getters: PropertiesGetters,
    mutations: PropertiesMutations,
    actions: PropertiesActions,
};
